import { useState } from "react";

import styled from "styled-components";
import { Popover, Badge, List, Avatar, message } from "antd";
// import Cookies from "universal-cookie";
// import { useHistory } from "react-router-dom";
import {
  BellFilled,
  CloseOutlined,
  BankOutlined,
  ExclamationOutlined,
  ShoppingCartOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
// import { useDispatch } from "react-redux";

// import { updateNotification } from "state/actions";
import { getNotificationState, getUserState } from "state/selector";
import colors from "constants/palette";
import Button from "components/buttons/Button";
import Fetch from "components/Fetch";
import { GlassCard } from "components/App/styled";
import ManageProductHeader from "components/buttons/ManageProductHeader";

function HeaderLeft({ notifications, user }) {
  // const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  var notifs = notifications.data ? notifications.data : [];
  console.log(notifications);
  // remove notif item with api call
  function removeNotif(key) {
    setLoading(key);
    var newNotif = notifs;
    newNotif.splice(key, 1);
    Fetch.put(
      `/users/${user.id}`,
      { notifications: JSON.stringify(newNotif) },
      (res) => {
        console.log("update users notif response", res);
        if (res.success) {
          // dispatch(updateNotification({ data: newNotif }));
        } else {
          message.error("خطایی رخ داده است");
        }
        setLoading(false);
      }
    );
  }

  const NotifContent = (
    <div style={{ width: 300, direction: "rtl" }}>
      {notifs?.length ? (
        <List
          loading={loading}
          itemLayout="horizontal"
          dataSource={notifs}
          renderItem={(item, key) => (
            <List.Item>
              <List.Item.Meta
                avatar={
                  <Avatar
                    src={
                      item.title.includes("سفارش") ? (
                        <ShoppingCartOutlined style={{ fontSize: "1.4rem" }} />
                      ) : item.title.includes("مبلغ") ? (
                        <BankOutlined style={{ fontSize: "1.4rem" }} />
                      ) : (
                        <ExclamationOutlined style={{ fontSize: "1.4rem" }} />
                      )
                    }
                  />
                }
                title={<a href={process.env.REACT_APP_URL}>{item.title}</a>}
                description={item.text}
              />
              <Button
                key={key}
                color={colors.red + "80"}
                style={{ width: 42, padding: "7px 0px" }}
                onClick={() => removeNotif(key)}
              >
                <CloseOutlined />
              </Button>
            </List.Item>
          )}
        />
      ) : (
        <div style={{ textAlign: "center", color: colors.dark }}>
          اعلان جدیدی وجود ندارد
        </div>
      )}
    </div>
  );
  return (
    <Container>
      {/* <DataContainer>
        <div>
          <span>سفارش فعال :</span> <span>{1}</span>
        </div>
        <div>
          <span>سفارش جدید : </span>
          <span>{1}</span>
        </div>
      </DataContainer> */}
      <ManageProductHeader />
      <Popover
        placement="bottomRight"
        title={""}
        content={NotifContent}
        trigger="click"
        style={{ width: 500 }}
      >
        <Badge count={notifs?.length}>
          <Button>
            <BellFilled style={{ fontSize: 26 }} />
          </Button>
        </Badge>
      </Popover>
    </Container>
  );
}
const mapStateToProps = (state) => {
  const notifications = getNotificationState(state);
  const user = getUserState(state);
  return { notifications, user };
};
export default connect(mapStateToProps)(HeaderLeft);
const Container = styled(GlassCard)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: ${colors.dark};
  height: 86%;
  padding: ${colors.bgImage ? "0 2%" : "0"};
`;
